import React from "react";

export const LoadingIndicator: React.FC = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/70 dark:bg-black/60 backdrop-blur-md">
      <div className="relative w-16 h-16">
        {/* Nền trắng hoặc trong suốt */}
        <div className="absolute inset-0 rounded-full border-[6px] border-blue-200" />

        {/* 1/4 vòng màu xanh */}
        <div className="absolute inset-0 animate-spinslow">
          <div className="w-full h-full rounded-full border-[6px] border-transparent border-t-blue-500 rotate-45" />
        </div>
      </div>
    </div>
  );
};
